import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import localForage from 'localforage';

import state from './state';
import * as getters from './getters';
import mutations from './mutations';
import actions from './actions';

import loadOldStoreModules from '@/store/utils/loadOldStoreModules';
import loadStoreModules from '@/store/utils/loadStoreModules';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: localForage,
  asyncStorage: true,
  key: process.env.VUE_APP_AMBIENTE
});

const oldModules = loadOldStoreModules();
const modules = loadStoreModules();

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    ...oldModules,
    ...modules
  },
  plugins: [vuexLocal.plugin]
});
